import { render, staticRenderFns } from "./InvestorRetentionTrxUpdater.vue?vue&type=template&id=1729a775&scoped=true&"
import script from "./InvestorRetentionTrxUpdater.vue?vue&type=script&lang=js&"
export * from "./InvestorRetentionTrxUpdater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1729a775",
  null
  
)

export default component.exports